import { mapToCanActivate, Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { CustomerGuard } from '@next/core-lib/relationships';

import { RegistrationComponent } from './registration/registration.component';
import { CropFieldOverviewComponent } from './reports/cropfield-overview/cropfield-overview.component';
import { SoilAnalysisReportComponent } from './reports/soil-analysis-report/soil-analysis-report.component';
import { SalesPotentialComponent } from './sales-potential/sales-potential.component';

const customerCanActivate = mapToCanActivate([CustomerGuard]);

export const appRoutes: Routes = [
  {
    path: '',
    component: RegistrationComponent,
    canActivate: customerCanActivate,
  },
  {
    path: 'sales-potential',
    component: SalesPotentialComponent,
    canActivate: customerCanActivate,
  },
  { path: 'cropfield-overview', redirectTo: 'cropfield-overview/', pathMatch: 'full' },
  {
    path: 'cropfield-overview/',
    component: CropFieldOverviewComponent,
    canActivate: customerCanActivate,
  },
  { path: 'soil-analysis/report', redirectTo: 'soil-analysis/report/', pathMatch: 'full' },
  {
    path: 'soil-analysis/report/:cropFieldsIdsReport',
    component: SoilAnalysisReportComponent,
    canActivate: customerCanActivate,
  },
  {
    path: 'soil-analysis/report/:cropFieldsIdsReport/:characteristicIds',
    component: SoilAnalysisReportComponent,
    canActivate: customerCanActivate,
  },
  ...coreRoutes,
];
